<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <fb-file-view
      :classMessage="messageClass"
      @update-links="updateLinks"
      @update-files="updateFiles"
      @update-error="updateError(true)"
      :data-props="saveData"
      :nid="nid"
    />
    <div class="text-left" v-bind:key="index" v-for="(val, index) in links">
      <component
        @delete="del(index)"
        @upload-file="fileUploaded(index, $event)"
        @upload-file-fail="fileUploadFail(index, $event)"
        :data-props="val"
        :clean-error="cleanError"
        @update-error="updateError(false)"
        :is="val.type == 'link' ? 'FbFileViewLink' : 'FbFileViewFile'"
      />
    </div>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'File'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <fb-file-view :data-props="saveData" />
    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field>
          <label>Help text</label>
          <md-input v-model="tempData.helptext"></md-input>
        </md-field>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import FbFileView from "./FbFileView.vue";
import FbFileViewFile from "./FbFileViewFile.vue";
import FbFileViewLink from "./FbFileViewLink.vue";

export default {
  name: "FbFile",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],
  components: {
    FbFileView,
    FbFileViewFile,
    FbFileViewLink,
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true,
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      val = !(
        this.saveData.required === true &&
        this.links.filter((el) => {
          if (el.type == "file" && el.uuid && el.uuid != "") {
            return true;
          } else if (el.type == "link" && el.link && el.link != "") {
            return true;
          }
          return false;
        }).length == 0
      );
      return val;
    },
    value() {
      if (this.valid) {
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: this.links
            .filter((el) => {
              return (
                (el.type == "file" && el.uuid && el.uuid != "") ||
                (el.type == "link" && el.link && el.link != "")
              );
            })
            .map((el) => {
              return {
                link: el.link,
                type: el.type,
                name: el.name,
                uuid: el.uuid,
                uri: el.uri,
              };
            }),
          type: this.element.type,
        };
      }
      return undefined;
    },
  },
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.links = window.drupalSettings.form_builder[this.nid]["submissions"][
        this.sid
      ][this.element.uuid].value.map((el) => {
        if (el.type == "file") {
          return {
            link: el.name,
            type: "file",
            buffer: undefined,
            name: el.name,
            uuid: el.uuid,
            uri: el.uri,
          };
        } else {
          return {
            link: el.link,
            type: "link",
          };
        }
      });
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  data() {
    return {
      links: [],
      files: [],
      tempData: {
        label: this.element.data.label || "",
        helptext: this.element.data.helptext || "",
        required: this.element.data.required || false,
      },
      saveData: {
        label: this.element.data.label || "",
        helptext: this.element.data.helptext || "",
        required: this.element.data.required || false,
      },
      cleanError: false,
    };
  },
  methods: {
    updateError(value) {
      this.cleanError = value;
    },
    updateLinks(links) {
      this.links = this.links.concat(
        links.map((el) => {
          return {
            link: el,
            type: "link",
          };
        })
      );
    },
    updateFiles(file) {
      this.links = this.links.concat([
        {
          link: file.name,
          type: "file",
          buffer: file.buffer,
          name: file.name,
          uuid: "",
          uri: "",
        },
      ]);
    },
    fileUploaded(index, file) {
      this.links[index].name = file.name;
      this.links[index].uuid = file.uuid;
      this.links[index].uri = file.uri;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    fileUploadFail(index) {
      this.links.splice(index, 1);
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    del(index) {
      this.links.splice(index, 1);
    },
  },
  watch: {
    links: function links() {
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
  },
};
</script>

<style scoped>
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
